import React from "react";
import classNames from "classnames";

import styles from "./accordeonCartes.module.scss";
import type { Recette } from "@/types/recette";
import type { Emission, Episode } from "@/types/emissions";
import type { Categorie } from "@/types/categorie";
import type { Publication } from "@/types/publication";
import { Viewport } from "@/types/enum";
import { SwiperSlide } from "swiper/react";
import Carte from "../cartes/carte";
import Slider from "../slider";

type AccordeonCartesProps = {
  className?: string;
  contenus: Recette[] | Episode[] | Categorie[] | Emission[] | Publication[];
  viewport: Viewport;
};

const AccordeonCartes = ({
  className = "",
  contenus,
}: AccordeonCartesProps) => {
  const options = {
    slidesPerView: 2,
    spaceBetween: 15,
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  };

  return (
    <div
      data-component="AccordeonCartes"
      data-testid={`accordeonCartes-l${contenus.length}`}
      className={classNames(styles.me, {
        [className]: className,
      })}
    >
      <Slider overrides={options}>
        {contenus?.map((contenu) => {
          const { id } = contenu;
          return (
            <SwiperSlide key={`contentUiDesktop-${id}`}>
              <div className={styles.block}>
                <Carte contenu={contenu} />
              </div>
            </SwiperSlide>
          );
        })}
        <div className={`${styles.sliderButton} swiper-button-next`}></div>
        <div className={`${styles.sliderButton} swiper-button-prev`}></div>
      </Slider>
    </div>
  );
};

export default AccordeonCartes;
